import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const publishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
    throw new Error("Faltan REACT_APP_SUPABASE_URL o REACT_APP_SUPABASE_PUBLISHABLE_KEY.");
}

export const supabase = createClient(url, publishableKey);
